// extracted by mini-css-extract-plugin
export default {"myLinksTableTight":"cizQEG1","rowInactive":"EF02A2R"};